var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.property.name == 'Application')?_c('td',[_c('ProductApplications',{attrs:{"product":_vm.product}})],1):_c('td',{class:{ 'bg-orange-200 border border-orange-diagomics-light': _vm.canHighlightCell }},[_vm._v("\n  "+_vm._s(this.getPropertyValues(_vm.property.name) || this.getOptionValues(_vm.property.name))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }